

class CartBase extends HTMLElement {
    constructor() {
        super();
        this.DEBOUNCE_DELAY = 100;
    }

    getContainer() {
        return this.container || document.querySelector('.js-cart-page');
    }

    async fetchCartUpdate(line, quantity) {
        try {
            const response = await fetch(`${routes.cart_change_url}`, {
                ...fetchConfig(),
                body: JSON.stringify({ id:line, quantity: quantity })
            });
            const state = await response.json();

            if (state.errors) {
                this.errorMessage(state, line);
                return false;
            }
            console.log('Cart updated')
            return true;
        } catch (error) {
            console.error('Cart update error:', error);
            return false;
        }
    }
}

class CartRemove extends CartBase {
    constructor() {
        super();
        this.itemSelector = 'cart-item';
        this.handleRemove = this.handleRemove.bind(this);
        this.debouncedOnChange = debounce(this.handleRemove, this.DEBOUNCE_DELAY);
        this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
        event.preventDefault();
        this.debouncedOnChange();
        this.getContainer().classList.add('loading');
    }

    async handleRemove() {
        const cartItem = this.closest( this.itemSelector);
        const line = cartItem?.dataset.itemIndex;
        if (cartItem && line) {
            const success = await cartItem.fetchCartUpdate(line, 0);
            if (success) {
                if(this.itemSelector == 'cart-item'){
                    cartItem.classList.add('removal')
                    this.closest('.shopping-bag-content')?.querySelector('.shopping-bag-list.removed-items')?.append(cartItem);
                    setTimeout(()=>{
                        cartItem.remove()
                    },5000)
                    await cartItem.updateCartContent();
                    this.getContainer().classList.remove('loading');
                }else{
                    cartItem.updateCartContent()
                }

            }

        }
    }
}
class CartPopupRemove extends CartRemove {
    constructor() {
        super();
        this.container = document.querySelector('.popup-content');
        this.itemSelector = 'popup-cart-item';
    }
}

class Cart extends CartBase {
    constructor() {
        super();

        this.itemSelector = 'cart-item';

        this.setupElements();
        this.bindEvents();
    }

    setupElements() {
        this.input = this.querySelector('input[name="quantity"]');
        this.buttons = this.querySelectorAll('.js-quantity-button');
    }

    bindEvents() {
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.debouncedOnChange = debounce(this.handleQuantityChange, this.DEBOUNCE_DELAY);

        if (this.input) {
            this.input.addEventListener('change', () => this.debouncedOnChange(this.input));
        }

        this.buttons?.forEach(button => {

            button.addEventListener('click', () => this.debouncedOnChange(button));
        });
    }

    async handleQuantityChange(element) {
        const cartItem = element.closest(this.itemSelector);
        if (!cartItem) return;

        const container = this.getContainer();
        container.classList.add('loading');

        const line = cartItem.dataset.itemIndex;
        const quantity = cartItem.querySelector('input[name="quantity"]').value;

        const success = await this.fetchCartUpdate(line, quantity);
        if (success) {
            await this.updateCartContent();
        }
    }

    async updateCartContent() {
        try {
            const response = await fetch(`${window.routes.cart_url}?section_id=template-cart`);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const elements = [
                {
                    fetch: '.shopping-bag-list.cart-items',
                    current: '.shopping-bag-list.cart-items',
                    updateMethod: 'innerHTML'
                },
                {
                    fetch: '[data-free-delivery]',
                    current: '[data-free-delivery]',
                    updateMethod: 'innerHTML'
                },
                {
                    fetch: '[data-cart-summary]',
                    current: '[data-cart-summary]',
                    updateMethod: 'innerHTML'
                },
                {
                    fetch: 'button[name="checkout"]',
                    current: 'button[name="checkout"]',
                    updateMethod: 'outerHTML'
                },
                {
                    fetch: '[data-empty-cart]',
                    current: '[data-empty-cart]',
                    updateMethod: 'innerHTML'
                },
                {
                    fetch: '[data-cart-title]',
                    current: '[data-cart-title]',
                    updateMethod: 'innerHTML'
                },
                {
                    fetch: '[data-existing-discount]',
                    current: '[data-existing-discount]',
                    updateMethod: 'innerHTML'
                }
            ];

            elements.forEach(({fetch, current, updateMethod}) => {
                const fetchedElement = doc.querySelectorAll(fetch);
                const currentElement = document.querySelectorAll(current);

                fetchedElement.forEach((fetchEl, index) => {

                    const currentEl = currentElement[index];
                    if (fetchEl && currentEl) {
                        currentEl[updateMethod] = fetchEl[updateMethod];
                        if(fetch === '[data-existing-discount]'){
                            setTimeout(()=>{
                                document.querySelector('cart-discount').bindRemoveEvents();
                            },500)
                        }
                    }
                });
            });
            if(document.querySelector('.shopping-bag-empty')){
                document.querySelector('.shopping-bag-content').style.display = 'none';
            }else{
                document.querySelector('.shopping-bag-content').removeAttribute('style')
            }

            this.getContainer().classList.remove('loading');
            updateCartEvents();
            updateCartCount();


            if (window.lazyLoadEnabled === "true") {
                reloadLazyLoad();
            }
        } catch (error) {
            console.error('Cart content update error:', error);
        }
    }

    errorMessage(resp, line) {
        const itemContainer = this.getContainer().querySelector(`[data-item-index="${line}"]`);
        if (!itemContainer) return;

        const quantityInput = itemContainer.querySelector('[name="quantity"]');
        const errorBlock = this.createErrorBlock(resp.errors);
        if(this.querySelector('.cart-item-error')){
          this.querySelector('.cart-item-error').innerHtml = resp.errors;
        }else{
          this.querySelector('.shopping-bag-item-content').append(errorBlock)
        }
        

        quantityInput.value = quantityInput.value - 1;


        updateCartCount();
        this.getContainer().classList.remove('loading');
    }

    createErrorBlock(error) {
        const errorBlock = document.createElement('p');
        errorBlock.classList.add('cart-item-error');
        errorBlock.classList.add('shopping-bag-item-options');
        errorBlock.innerHTML = error;
        return errorBlock;
    }
}

class PopupCart extends Cart {
    constructor() {
        super();
        this.container = document.querySelector('.popup-content');
        this.itemSelector = 'popup-cart-item';
    }

    async updateCartContent() {
        await updateCartPopup();
        updateCartCount();
    }
    errorMessage(resp, line) {
        const itemContainer = this.getContainer().querySelector(`[data-item-index="${line}"]`);
        if (!itemContainer) return;

        const quantityInput = itemContainer.querySelector('[name="quantity"]');
        const errorBlock = this.createErrorBlock(resp.errors);
       if(this.querySelector('.cart-item-error')){
          this.querySelector('.cart-item-error').innerHtml = resp.errors;
        }else{
           this.querySelector('.cart-popup-item-name').after(errorBlock)
        }

       
        quantityInput.value = quantityInput.value - 1;

        updateCartCount();
        this.getContainer().classList.remove('loading');
    }

    createErrorBlock(error) {
        const errorBlock = document.createElement('p');
        errorBlock.classList.add('cart-item-error');
        errorBlock.classList.add('cart-popup-item-brand');
        errorBlock.innerHTML = error;
        return errorBlock;
    }
}

customElements.define('remove-item', CartRemove);
customElements.define('popup-remove-item', CartPopupRemove);
customElements.define('cart-item', Cart);
customElements.define('popup-cart-item', PopupCart);

function updateCartEvents(){
    var quantityInput = document.querySelectorAll('cart-item .quantity');
    if (quantityInput.length) {
        quantityInput.forEach(function (quantity) {
            var plus = quantity.querySelector('.quantity-button--plus');
            var minus = quantity.querySelector('.quantity-button--minus');
            var input = quantity.querySelector('.quantity-input');
            if (plus) {
                plus.addEventListener('click', function () {
                    var value = Number(input.value);
                    value++;
                    input.value = value;
                    if (value > 1) {
                        minus.classList.remove('_disabled')
                    }
                })
            }
            if (minus) {
                minus.addEventListener('click', function () {
                    var value = Number(input.value);
                    if (value > 1) {
                        value--;
                        input.value = value;
                        if (value == 1) {
                            minus.classList.add('_disabled')
                        }
                    }
                })
            }
        })
    }
}

class CartDiscount extends HTMLElement {
    constructor() {
        super();
        this.DEBOUNCE_DELAY = 300;
        this.init();
    }

    init() {
        this.form = this.querySelector('.discount-code-form');
        this.input = this.querySelector('input[name="discount"]');
        this.submitButton = this.querySelector('button[type="submit"]');
        this.existingDiscountContainer = this.querySelector('[data-existing-discount]');
        this.errorText = this.querySelector('.js-form-field-error');

        this.bindEvents();
        this.bindRemoveEvents();
    }

    bindEvents() {
        this.handleSubmit = this.handleSubmit.bind(this);
        this.debouncedSubmit = debounce(this.handleSubmit, this.DEBOUNCE_DELAY);

        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                this.debouncedSubmit();
            });
        }

        if (this.input) {
            this.input.addEventListener('input', () => {
                this.submitButton.classList.toggle('_disabled', !this.input.value.trim());
                this.errorText.style.display = 'none';
            });
        }
        if (this.existingDiscountContainer) {
            this.input.addEventListener('input', () => {
                this.submitButton.classList.toggle('_disabled', !this.input.value.trim());
                this.errorText.style.display = 'none';
            });
        }

    }
    bindRemoveEvents(){
        if (this.existingDiscountContainer) {
            const removeButtons = this.existingDiscountContainer.querySelectorAll('[data-discount-item]');

            removeButtons.forEach(button => {

                button.addEventListener('click', (e) => {

                    this.removeDiscount(button.dataset.code);
                });
            });
        }
    }


    async handleSubmit() {
        const discountCodeValue = this.input.value.trim();
        if (!discountCodeValue) return;
        const existingDiscounts = this.getExistingDiscounts();

        if (existingDiscounts.includes(discountCodeValue)) {
            return;
        }
        this.submitButton.classList.add('loading');

        const data = await this.applyDiscount([...existingDiscounts, discountCodeValue]);

        if (
            data.discount_codes.find((discount) => {
                return discount.code === discountCodeValue && discount.applicable === false;
            })
        ) {
            const message = window.translations.discount_error.replace('{{code}}', discountCodeValue)
            this.errorMessage(message);
            return;
        }
        console.log(data)
        await this.handleSuccess();
        this.updateDiscountBlock([...existingDiscounts, discountCodeValue]);

        // await this.applyDiscount(discounts);
    }

    async applyDiscount(discounts) {
        try {
            const response = await fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                body: JSON.stringify({ discount: discounts.join(',') })
            });
            const state = await response.json();

            if (state.errors) {
                console.log(state)
                // this.errorMessage(state);
                return false;
            }
            console.log('Discount applied')
            return state;
        } catch (error) {
            console.error('Discount added error:', error);
            return false;
        } finally {
            this.submitButton.classList.remove('loading');
        }
    }
    async removeDiscount(codeToRemove) {
        const existingDiscounts = this.getExistingDiscounts();
        const updatedDiscounts = existingDiscounts.filter(code => code !== codeToRemove);

        try {
            const data = await this.applyDiscount(updatedDiscounts);
            console.log('Discount Remove');
            await this.handleSuccess();
            this.updateDiscountBlock(updatedDiscounts);

        } catch (error) {
            console.error('Failed to remove discount:', error);
            // this.errorMessage(window.translations.discount_remove_error || 'Failed to remove discount');
        }
    }

    getExistingDiscounts(){
        if(!this.existingDiscountContainer) return;


        const discountItems = this.existingDiscountContainer.querySelectorAll('[data-discount-item]');
        return Array.from(discountItems)
            .map(item => item.dataset.code)
            .filter(code => code);

    }
    updateDiscountBlock(discounts) {
        if (!this.existingDiscountContainer) return;

        discounts.forEach(discount=>{
            console.log(discount)
            if(!this.existingDiscountContainer.querySelector(`[data-code="${discount}"]`)){
                this.errorMessage(window.translations.shipping_discount_error);
            }
        })

        this.input.value = '';
        this.submitButton.classList.add('_disabled');

    }
    async handleSuccess() {

        this.input.value = '';
        // Update cart summary
       await document.querySelector('cart-item')?.updateCartContent();
    }


    errorMessage(message) {
        console.log(message)
        this.input.value = '';
        this.errorText.textContent = message;
        this.errorText.style.display = 'block';
        this.input.classList.add('__has-error');
        this.submitButton.classList.remove('loading');
    }
}

customElements.define('cart-discount', CartDiscount);